module.exports = __webpack_public_path__ + "PTMETTAservice-6.66e321ee.png";